import { Circle as CircleStyle, Fill, Stroke, Style, Text, Icon } from 'ol/style';
import stopIcon from '../../../../assets/icons/stop-sign.svg';
import pointIcon from '../../../../assets/icons/point.png';

const vectorStyleRoutePointNumberInside = new Style({
  image: new CircleStyle({
    fill: new Fill({ color: '#fff' }),
    stroke: new Stroke({ color: '#1876d2', width: 1 }),
    radius: 14,
  }),
  text: new Text({
    font: '13px roboto',
    overflow: true,
    fill: new Fill({ color: 'black' }),
  }),
});

export const baseLineStyle = new Style({
  stroke: new Stroke({ color: '#0e97fa', width: 4 }),
});

export const baseLineStyleFun = (color) => {
  return new Style({
    stroke: new Stroke({ color: color || '#0e97fa', width: 4 }),
  });
};

export const fastLineStyle = new Style({
  stroke: new Stroke({ color: '#ff0000', width: 4 }),
});

export const stopPointStyle = new Style({
  image: new Icon({
    scale: 0.5,
    src: stopIcon,
    anchor: [0.5, 0.5],
  }),
});

// Задание стилей для векторного слоя
export const vectorStyleCurrentPoint = new Style({
  image: new CircleStyle({
    fill: new Fill({
      color: '#1876d2',
    }),
    stroke: new Stroke({
      color: '#1876d2',
      width: 1,
    }),
    radius: 14, // Adjust the radius of the circle as needed
  }),

  text: new Text({
    font: '13px roboto',
    overflow: true,
    fill: new Fill({
      color: '#fff', // Text color
    }),
  }),
});

// Задание стилей для векторного слоя
export const vectorStyleRoutePoint = new Style({
  image: new Icon({
    scale: 0.6,
    src: pointIcon,
    anchor: [0.5, 1],
  }),
  text: new Text({
    font: '14px roboto',
    overflow: true,
    fill: new Fill({
      color: 'black',
    }),
    stroke: new Stroke({
      color: 'white',
      width: 3,
    }),
    offsetY: -45,
  }),
});

// Задание стилей для векторного слоя
export const vectorStyleRoutePointOnlyTextMarker = new Style({
  text: new Text({
    font: '14px roboto',
    overflow: true,
    fill: new Fill({
      color: 'black',
    }),
    stroke: new Stroke({
      color: 'white',
      width: 3,
    }),
    offsetY: -25,
  }),
});

// Задание стилей для векторного слоя с числом внутри
export const vectorStyleRoutePointNumberInsideMarker = new Style({
  image: new CircleStyle({
    fill: new Fill({
      color: '#fff',
    }),
    stroke: new Stroke({
      color: '#1876d2',
      width: 1,
    }),
    radius: 14, // Adjust the radius of the circle as needed
  }),

  text: new Text({
    font: '13px roboto',
    overflow: true,
    fill: new Fill({
      color: '#1876d2', // Text color
    }),
  }),
});

export default vectorStyleRoutePointNumberInside;
